import { useEffect } from 'react'

// vike-react renders <Head> (and thus WebsiteHelmet's <title>) only during
// SSR, so client-side navigations keep the previous page's title (WEB-342).
// vike-react's `title` setting would sync it, but it force-emits an og:title
// ahead of <Head> content, overriding page-specific OG titles — hence this
// manual sync.
export function useDocumentTitle(title: string) {
  useEffect(() => {
    document.title = title
  }, [title])
}
